var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLiked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M490.331 274.998L464.913 410.426C461.212 430.129 453.561 447.234 442.801 459.9C429.739 475.258 412.761 483.379 393.693 483.379H221.213C215.73 483.379 210.39 482.72 205.258 481.472V195.349C251.457 146.372 295.74 84.0341 314.502 38.5261C316.972 32.5331 322.81 28.6211 329.292 28.6211C357.791 28.6211 379.34 40.4941 389.982 62.0521C399.422 81.1911 399.732 106.891 390.869 136.377C385.069 155.694 375.549 175.984 362.9 196.147H419.119C440.371 196.147 462.248 206.611 476.23 223.453C488.734 238.524 493.741 256.827 490.331 274.998ZM135.428 187.133H66.927C41.396 187.133 20.627 207.902 20.627 233.432V437.08C20.627 462.607 41.396 483.38 66.927 483.38H135.428C151.044 483.38 164.871 475.598 173.259 463.715V206.797C164.874 194.911 151.046 187.133 135.428 187.133Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLiked);
export default __webpack_public_path__ + "static/media/liked.20c13870ed380fabc9516b289bc01a7e.svg";
export { ForwardRef as ReactComponent };